import React, { useEffect, useState } from 'react';
import Pagination from '../../pagination';

export const Pager = props => {
  const { controller } = props;
  const { labels } = props;
  const [state, setState] = useState(controller.state);

  useEffect(
    () => controller.subscribe(() => setState(controller.state)),
    [controller]
  );

  state.currentPages.filter(page => page > 0 && page < state.maxPage);

  if (state.maxPage < 1) {
    return;
  }

  return (
    <Pagination
      totalPages={state.maxPage}
      currentPage={state.currentPage}
      onPageChange={controller.selectPage}
      nextPageLabel={labels.nextPage}
      previousPageLabel={labels.previousPage}
      pageLabel={labels.page}
    />
  );
};
